/**
 * Responsive breakpoints for web layouts
 *
 * Uses standard breakpoint values for mobile-first responsive design:
 * - mobile: < 768px (phones)
 * - tablet: 768px - 1024px (tablets)
 * - desktop: > 1024px (desktop screens)
 */
export const breakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1440,
} as const

export type Breakpoint = keyof typeof breakpoints
